import { useAuthContext } from './useAuthContext';
import { useAdminCategoriesContext } from './useAdminCategoriesContext';

export const useLogout = () => {
    const { dispatch } = useAuthContext();
    const { dispatch: categoriesDispatch } = useAdminCategoriesContext();

    const logout = () => {
        localStorage.removeItem('user');
        dispatch({ type: 'LOGOUT' });
        categoriesDispatch({ type: 'SET_CATEGORIES', payload: null });
    }

    return { logout };
}